import { render, staticRenderFns } from "./FormOrganizationConfig.vue?vue&type=template&id=023c9789&"
import script from "./FormOrganizationConfig.vue?vue&type=script&lang=js&"
export * from "./FormOrganizationConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports